module.exports = __webpack_public_path__ + "img/batman_dc-comics_feature.aafdb7ea.jpg";